import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import NoPage from './pages/NoPage'
import './global.css'
import Vehicles from './pages/Vehicles'
import PrivateRoute from './components/PrivateRoute'
import Importers from './pages/Importers'
import Store from './context/global_context'
import DtcApp from './pages/vehicles/dtcs'
import TatDtcMappings from './pages/vehicles/dtcs/TaTmappings'
import DtcEdit from './pages/vehicles/dtcs/DtcEdit'
import TatConnectorMapping from './pages/vehicles/dtcs/TaTmappings/ConnectorMapping'
import ConnectorViews from './pages/vehicles/connector_views'
import ConnectorViewEdit from './pages/vehicles/connector_views/edit'
import ConnectorViewNew from './pages/vehicles/connector_views/new'
import ConnectorViewEditMappings from './pages/vehicles/connector_views/edit_mappings'
import Administration from './pages/administration'
import EditVehicle from './pages/vehicles/edit'
import CreateNewVehicle from './pages/vehicles/new'
import PowerDistributions from './pages/vehicles/power_distributions'
import Auth from './pages/auth'
import NotPermitted from './pages/not_permitted'
import LogoutSuccess from './pages/logout_success'
import SystemAndSubSystem from './pages/system_and_sub_system'
import Plugin from './pages/vehicles/plugin'
import InlinesConnections from './pages/vehicles/inlines'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Store>
              <Layout />
            </Store>
          }
          key={'home'}
        >
          <Route path="users/sign_in" index element={<Login />} key={'login'} />
          <Route path={`auth/`} element={<Auth />} key={'auth'} />
          <Route
            path="not_permitted/"
            element={<NotPermitted />}
            key={'not_permitted'}
          />
          <Route
            path="logout_success/"
            element={<LogoutSuccess />}
            key={'logout_success'}
          />
          <Route exact element={<PrivateRoute />}>
            <Route path="vehicles/" element={<Vehicles />} key={'vehicles'} />
            <Route
              path="vehicles/:vehicle/edit"
              element={<EditVehicle />}
              key={'vehicles_edit'}
            />
            <Route
              path="vehicles/new"
              element={<CreateNewVehicle />}
              key={'vehicles_create'}
            />

            <Route
              path={`vehicles/:vehicle/importers`}
              element={<Importers />}
              key={'vehicle_importers'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs`}
              element={<DtcApp />}
              key={'dtcs'}
            />
            <Route
              path={`vehicles/:vehicle/plugin`}
              element={<Plugin />}
              key={'def_plugin'}
            />
            <Route
              path={`vehicles/:vehicle/inlines`}
              element={<InlinesConnections />}
              key={'inlines'}
            />
            <Route
              path={`vehicles/:vehicle/power_distributions`}
              element={<PowerDistributions />}
              key={'power_distributions'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/mappings`}
              element={<TatDtcMappings />}
              key={'tat_dtcs_mappings'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/:dtc_id/edit`}
              element={<DtcEdit />}
              key={'tat_dtc_edit'}
            />
            <Route
              path={`vehicles/:vehicle/dtcs/mappings/:connector_id`}
              element={<TatConnectorMapping />}
              key={'tat_dtcs_connector_mappings'}
            />
            <Route
              path={`vehicles/:vehicle/connector_views`}
              element={<ConnectorViews />}
              key={'connector_views'}
            />

            <Route
              path={`vehicles/:vehicle/connector_views/new`}
              element={<ConnectorViewNew />}
              key={'connector_views_new'}
            />

            <Route
              path={`vehicles/:vehicle/connector_views/:connector_view/edit`}
              element={<ConnectorViewEdit />}
              key={'connector_views_edit'}
            />

            <Route
              path={`vehicles/:vehicle/connector_views/:connector_view/edit_mappings`}
              element={<ConnectorViewEditMappings />}
              key={'connector_views_edit_mappings'}
            />

            <Route
              path={`administration/`}
              element={<Administration />}
              key={'administration'}
            />

            <Route
              path={`system_and_sub_system/`}
              element={<SystemAndSubSystem />}
              key={'system_and_sub_system'}
            />
            <Route path="*" element={<NoPage />} key={'no_page'} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
